package br.com.texeratx.boardgametimeapp.ui.screens.games

import br.com.texeratx.boardgametimeapp.ui.screens.games.model.GameUI

data class GamesUiState(
    val isLoading: Boolean = false,
    val error: String? = null,
    val sort: GameSortOption = GameSortOption.ALPHABETICAL,
    val games: List<GameUI> = emptyList(),
    val searchQuery: String = "",
    val filters: GamesFilter = GamesFilter(),
    val availableCategories: List<String> = emptyList(),
    val availableModes: List<String> = emptyList()
)
